import { Dialog, IconButton, Tooltip } from "@mui/material";
import { MuiColor } from "common/hooks/useMuiColor";
import { MuiIcon } from "common/components/types";
import React, { ReactNode, useCallback, useState } from "react";

interface SummaryCardEditDialogButtonProps {
  buttonTooltip: string;
  color?: MuiColor;
  iconClassName: string;
  IconComponent: MuiIcon;
  children: (renderProps: { close: () => void }) => ReactNode;
}

export const SummaryCardEditButtonDialog: React.FC<
  SummaryCardEditDialogButtonProps
> = ({ buttonTooltip, color, iconClassName, IconComponent, children }) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const close = useCallback(() => setDialogOpen(false), [setDialogOpen]);

  return (
    <>
      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
        {children({ close })}
      </Dialog>
      <Tooltip title={buttonTooltip} arrow>
        <IconButton
          color={color}
          className={iconClassName}
          size="medium"
          onClick={() => setDialogOpen(true)}
        >
          <IconComponent style={{ color: "inherit", fontSize: "inherit" }} />
        </IconButton>
      </Tooltip>
    </>
  );
};
